import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { v4 as uuidv4 } from 'uuid';
export const chatsAtom = atomWithStorage('chats', []);
export const currentChatIdAtom = atomWithStorage('current_chat_id', null);
export const messagesMapAtom = atomWithStorage('chat_messages', {});
export const currentChatAtom = atom((get) => {
    const chats = get(chatsAtom);
    const id = get(currentChatIdAtom);
    return chats.find((c) => c.id === id) || null;
});
export const currentMessagesAtom = atom((get) => {
    const id = get(currentChatIdAtom);
    const map = get(messagesMapAtom);
    return (id && map[id]) || [];
});
export const createChatAtom = atom(null, (get, set, title, scriptId) => {
    const id = uuidv4();
    const now = Date.now();
    const chat = {
        id,
        title: title || 'New Chat',
        createdAt: now,
        updatedAt: now,
        scriptId,
    };
    const chats = get(chatsAtom);
    set(chatsAtom, [chat, ...chats]);
    const map = get(messagesMapAtom);
    set(messagesMapAtom, {
        ...map,
        [id]: [],
    });
    set(currentChatIdAtom, id);
});
export const renameCurrentChatAtom = atom(null, (get, set, title) => {
    const id = get(currentChatIdAtom);
    if (!id)
        return;
    const chats = get(chatsAtom).map((c) => (c.id === id ? { ...c, title, updatedAt: Date.now() } : c));
    set(chatsAtom, chats);
});
export const sendMessageAtom = atom(null, (get, set, message) => {
    const id = get(currentChatIdAtom);
    if (!id)
        return;
    const map = get(messagesMapAtom);
    const now = Date.now();
    const msg = { id: uuidv4(), role: message.role, content: message.content, raw: message.raw ?? message.content, timestamp: now };
    const history = map[id] || [];
    const updated = [...history, msg];
    set(messagesMapAtom, { ...map, [id]: updated });
    const chats = get(chatsAtom).map((c) => (c.id === id ? { ...c, updatedAt: now } : c));
    set(chatsAtom, chats);
});
export const deleteChatAtom = atom(null, (get, set, chatId) => {
    const chats = get(chatsAtom).filter((c) => c.id !== chatId);
    set(chatsAtom, chats);
    const map = get(messagesMapAtom);
    const { [chatId]: removed, ...rest } = map;
    set(messagesMapAtom, rest);
    const current = get(currentChatIdAtom);
    if (current === chatId) {
        set(currentChatIdAtom, chats[0]?.id || null);
    }
});
// Append assistant streaming chunk to current chat
export const appendAssistantChunkAtom = atom(null, (get, set, chunk) => {
    if (typeof chunk !== 'string' || chunk.length === 0)
        return;
    const id = get(currentChatIdAtom);
    if (!id)
        return;
    const map = get(messagesMapAtom);
    const history = map[id] || [];
    if (history.length > 0 && history[history.length - 1].role === 'assistant') {
        const last = history[history.length - 1];
        // Streaming阶段仅更新显示内容；原文在最终完成时写入
        const updatedLast = { ...last, content: (last.content || '') + chunk, timestamp: Date.now() };
        const updated = [...history.slice(0, -1), updatedLast];
        set(messagesMapAtom, { ...map, [id]: updated });
    }
    else {
        const newMsg = { id: uuidv4(), role: 'assistant', content: chunk, timestamp: Date.now() };
        const updated = [...history, newMsg];
        set(messagesMapAtom, { ...map, [id]: updated });
    }
});
